import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Doorbell from './components/Doorbell';

interface Location {
  name: string;
  address: string;
  googleMapsLink: string;
  isFree?: boolean;
  distance?: string;
  closingTime?: string;
}

const App: React.FC = () => {
  const partyLocation: Location = {
    name: "Casa Tomi",
    address: "Calle León Nº1, La Orotava",
    googleMapsLink: "https://maps.google.com/?q=Calle+Leon+1,+La+Orotava"
  };

  const callBell = () => {
    fetch('https://ntfy.sh/tvcologan-hbtm-30-leon1', {
        method: 'POST',
        body: "¡Alguien está en la puerta!"
      });
  };

  const parkingLocations: Location[] = [
    {
      name: "Parking Lercaro",
      address: "Av. de Graham Toler, 10, 38300 La Orotava, Santa Cruz de Tenerife",
      googleMapsLink: "https://maps.app.goo.gl/akHYLUHZio5JZPvF9",
      isFree: true,
      distance: "450 m - 6 min",
      closingTime: "24 H"
    },
    {
      name: "Parking Gratuito La Ootava",
      address: "Av. la Torrita, 28, 38300 La Orotava, Santa Cruz de Tenerife",
      googleMapsLink: "https://maps.app.goo.gl/8idscx41y5EuCwRr9",
      isFree: true,
      distance: "600 m - 10 min",
      closingTime: "24 H"
    },
    {
      name: "Parking Orotava Centro",
      address: "C. Inocencio García, 5, 38300 La Orotava, Santa Cruz de Tenerife",
      googleMapsLink: "https://maps.app.goo.gl/PoHbugm7HCLwtgmh7",
      isFree: false,
      distance: "120 m - 2 min",
      closingTime: "23:00 Hrs"
    }
  ];

  const partyDate = "Sábado, 28 de Marzo de 2026";
  const partyTime = "7:00 PM";

  return (
    <Router>
      <Routes>
        <Route path="/doorbell" element={<Doorbell />} />
        <Route path="/" element={
          <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
            {/* Header */}
            <header className="bg-gradient-to-r from-pink-500 to-purple-600 text-white py-8 px-4 shadow-lg">
              <div className="max-w-6xl mx-auto text-center">
                <h1 className="text-3xl md:text-4xl font-bold mb-2">🎉 ¡Fiesta de Cumpleaños! 🎂</h1>
                <p className="text-lg md:text-xl opacity-90">¡Te invitamos a celebrar con nosotros!</p>
              </div>
            </header>

            <main className="max-w-6xl mx-auto px-4 py-8 space-y-8">
              {/* Date and Time Section */}
              <section className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">📅 Fecha y Hora</h2>
                <div className="text-center space-y-2">
                  <p className="text-lg text-gray-700">{partyDate}</p>
                  <p className="text-lg font-semibold text-purple-600">{partyTime}</p>
                </div>
              </section>

              {/* Party Location Section */}
              <section className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">📍 Ubicación de la Fiesta</h2>
                <div className="space-y-4">
                  <div className="text-center">
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">{partyLocation.name}</h3>
                    <p className="text-gray-600 mb-4">{partyLocation.address}</p>
                    <div onClick={callBell}>
                      <p className="text-gray-600 mb-4">Toca el timbre <span className="text-2xl">🔔</span></p>
                    </div>
                    <a
                      href={partyLocation.googleMapsLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block bg-purple-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors duration-200"
                    >
                      🗺️ Ver en Google Maps
                    </a>
                  </div>
                  
                  {/* Map Image */}
                  <div className="mt-6">
                    <iframe title="party_location" className="w-full h-64 md:h-96 object-cover rounded-lg shadow-sm" src="https://www.google.com/maps/embed?pb=!4v1774615590807!6m8!1m7!1srLQKHMdUt6-4nvw1WlN1Rg!2m2!1d28.3898005858748!2d-16.5243463043113!3f76.77800738817082!4f-6.43790953611304!5f0.4000000000000002" width="600" height="450" style={{border:0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                    {/* <img
                      src="https://via.placeholder.com/800x400/9333ea/ffffff?text=Mapa+de+Ubicación"
                      alt="Mapa de la ubicación de la fiesta"
                      className="w-full h-64 md:h-96 object-cover rounded-lg shadow-sm"
                    /> */}
                  </div>
                </div>
              </section>

              {/* Parking Locations Section */}
              <section className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">🚗 Estacionamientos Cercanos</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {parkingLocations.map((parking, index) => (
                    <div key={index} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow duration-200">
                      <h3 className="font-semibold text-gray-800 mb-2">{parking.name}</h3>
                      <p className="text-sm text-gray-600 mb-3">{parking.address}</p>
                      {parking.isFree ? <p className="text-sm text-green-600 mb-3">✅ Estacionamiento gratuito</p> : <p className="text-sm text-red-600 mb-3">❌ Estacionamiento de pago</p>}
                      {parking.closingTime && <p className="text-sm text-gray-500 mb-3">🕐 Horario: {parking.closingTime}</p>}
                      {parking.distance && <p className="text-sm text-gray-500 mb-3">{parking.distance}</p>}
                      <a
                        href={parking.googleMapsLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block w-full bg-blue-500 text-white px-4 py-2 rounded text-center text-sm font-medium hover:bg-blue-600 transition-colors duration-200"
                      >
                        📍 Ver en Maps
                      </a>
                    </div>
                  ))}
                </div>
              </section>

              {/* Additional Information */}
              <section className="bg-gradient-to-r from-purple-100 to-pink-100 rounded-lg p-6 text-center">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">🎊 Información Adicional</h2>
                <div className="space-y-2 text-gray-700">
                  <p className="text-lg">🎵 Música</p>
                  <p className="text-lg">🍕 Comida</p>
                  <p className="text-lg">🍻 Bebida</p>
                  <p className="text-lg">🥳 ¡Trae tu mejor actitud de fiesta!</p>
                </div>
              </section>

              {/* Contact/RSVP Section */}
              <section className="bg-white rounded-lg shadow-md p-6 text-center">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">📲 Si tienes cualquier duda</h2>
                <p className="text-gray-600 mb-4">Llamas a Tomi</p>
                <div className="space-y-2">
                  <p className="text-lg">📞 Teléfono: <a href="tel:606701075">606 70 10 75</a></p>            
                </div>
              </section>
            </main>

            {/* Footer */}
            <footer className="bg-gray-800 text-white py-6 px-4 mt-12">
              <div className="max-w-6xl mx-auto text-center">
                <p className="mb-2">¡Esperamos verte allí! 🎉</p>
                <p className="text-sm opacity-75">Hecho con ❤️ para celebrar</p>
              </div>
            </footer>
          </div>
        } />
      </Routes>
    </Router>
  );
};

export default App;
